export const getSystemDocumentApi = (params, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/${params?.leaseSlug}/system-documents/modules-list${queryString ? `?${queryString}` : ""}`;
};

export const getSystemDocumentsModuleFilesApi = (params, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/${params?.leaseSlug}/system-documents/${params.module}/files${queryString ? `?${queryString}` : ''}`;
};

export const getSystemDocumentAssembliesApi = (params) => {
    return `lease/${params?.leaseSlug}/system-documents/${params.module}/assemblies`;
};

export const getSystemDocumentAssemblyFilesApi = (params, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/${params?.leaseSlug}/system-documents/${params.module}/assemblies/${params.assemblySlug}/files${queryString ? `?${queryString}` : ''}`;
};